import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective} from '@angular/forms';
import { Package } from '@app/_models';

@Component({
  selector: 'app-package-details',
  templateUrl: './package-details.component.html',
  styleUrls: ['./package-details.component.less']
})
export class PackageDetailsComponent implements OnInit {

  @Output() selectPackage: EventEmitter<string> = new EventEmitter();
  @Input() package: Package;
  @Input() form: UntypedFormGroup;
  standardDescription: string;
  

  constructor(private rootFormGroup: FormGroupDirective) { }

  ngOnInit(): void {
    
  }

  onClick(packageID: string) {
    if (packageID === this.package.id) {
      this.selectPackage.emit(packageID);
    }
  }
}
